import { z } from "zod";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
import { pushPlatformSchema } from "./enums.js";
/**
 * Push cihazı kaydı (Prompt 21, ADR 0021 §5; tablo `push_devices` — ADR 0020). Kayıt ETKİN kiracıda yapılır; aynı belirteç
 * yeniden gelirse satır güncellenir (etkinleşir, son görülme tazelenir). Belirteç gizli değildir ama yanıtta ve günlüklerde
 * yalnızca kısaltılmış hâli görünür.
 */
/** Expo push belirteci: `ExponentPushToken[…]` ya da `ExpoPushToken[…]`. */
export const expoPushTokenSchema = z
    .string()
    .trim()
    .regex(/^Expo(nent)?PushToken\[[A-Za-z0-9_-]{10,200}\]$/, "Geçerli bir Expo push belirteci değil")
    .describe("Expo push belirteci");
export const registerPushDeviceSchema = z.object({
    platform: pushPlatformSchema,
    token: expoPushTokenSchema,
    deviceName: z.string().trim().min(1).max(100).nullable().default(null),
    appVersion: z.string().trim().min(1).max(40).nullable().default(null),
});
export const unregisterPushDeviceSchema = z.object({ token: expoPushTokenSchema });
export const pushDeviceSchema = z.object({
    id: uuidSchema,
    platform: pushPlatformSchema,
    /** Belirtecin kısaltılmış hâli (`ExponentPushToken[abcd…wxyz]`). */
    tokenPreview: z.string(),
    deviceName: z.string().nullable(),
    appVersion: z.string().nullable(),
    isActive: z.boolean(),
    lastSeenAt: timestampSchema,
    createdAt: timestampSchema,
});
export const pushDeviceListSchema = z.object({ items: z.array(pushDeviceSchema) });
export const unregisterPushDeviceResultSchema = z.object({ deactivated: z.number().int().nonnegative() });
/** Belirteci günlük / yanıt için kısaltır: ilk 4 ve son 4 karakter. */
export function maskPushToken(token) {
    const match = /^(Expo(?:nent)?PushToken\[)(.*)(\])$/.exec(token);
    if (!match)
        return "…";
    const inner = match[2];
    const short = inner.length <= 8 ? "…" : `${inner.slice(0, 4)}…${inner.slice(-4)}`;
    return `${match[1]}${short}${match[3]}`;
}
//# sourceMappingURL=push-devices.js.map